import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import useEtaStatus from "../../../hooks/useEtaStatus/useEtaStatus";
import TextPill from "../../Pills/TextPill/TextPill";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";

export default function EtaStatusPill({ value, tooltip, exceptions, tabValue }) {
  const { currentStatus } = useEtaStatus(value, exceptions, tabValue);

  if (!currentStatus || currentStatus?.id < 0) return null;

  const { name, backgroundColor } = { ...currentStatus };

  return (
    <StyledTooltip
      title={typeof (tooltip) === "string" ? tooltip : ""}
      titleObject={typeof (tooltip) === "object" ? tooltip : null}
    >
      <Box>
        <TextPill
          value={name}
          backgroundColor={backgroundColor}
          width="60px"
          padding="2px 6px"
          margin="-4px 0 0 0"
        />
      </Box>
    </StyledTooltip>
  );
}

EtaStatusPill.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]),
  exceptions: PropTypes.object,
  tabValue: PropTypes.any
};